import { Layout, Space } from 'antd'
import { Content } from 'antd/es/layout/layout'
import { ExportButton } from '../../components/Export/ExportButton'
import { GoBarButton } from '../../components/GoBar/GoBarButton'
import { SettingsPanel } from '../../components/SettingsPanel'
import { DocumentStructure } from '../../components/Document/DocumentStructure'
import { Navigation } from '../../components/Navigation/Navigation'
import { SaveIndicator } from '../../components/Editor/SaveIndicator'
import { LineItemDetailsDrawer } from '../../components/LineItem/LineItemDetailsDrawer/LineItemDetailsDrawer'
import React from 'react'
import { MoreDocumentControls } from './MoreDocumentControls'
import { PreviewButton } from './PreviewButton'
import { ImageLightbox } from '../../components/Common/ImageLightbox'

const SettingsPanelMemo = React.memo(SettingsPanel)
const LineItemDrawerMemo = React.memo(LineItemDetailsDrawer)
const ImageLightboxMemo = React.memo(ImageLightbox)

export const DocumentEditorLayout = () => {
  return (
    <Layout className="min-h-screen">
      <Navigation />
      <Layout
        style={{ justifyContent: 'center' }}
        className="bg-white rounded-lg shadow-sm flex flex-col min-[930px]:flex-row"
      >
        <Content
          style={{ maxWidth: 1050, overflowX: 'auto' }}
          className="px-2 sm:px-6 pt-6 pb-12"
        >
          <Space className="justify-end flex px-4 mb-4">
            <SaveIndicator />
            <GoBarButton />
            <PreviewButton />
            <ExportButton />
            <MoreDocumentControls />
          </Space>
          <DocumentStructure />
        </Content>

        <div className="w-full min-[930px]:w-[250px] xl:w-[350px] px-2 sm:px-6 min-[930px]:px-0 pt-6 me-0 lg:me-6">
          <SettingsPanelMemo />
        </div>
        <LineItemDrawerMemo />
        <ImageLightboxMemo />
      </Layout>
    </Layout>
  )
}
